<template lang="pug">
  #blogsnavbar
    // Navbar
    .blogs-navbar
      #bar.container-fluid.align-items-center
        .row.home-nav.d-flex.px-0.py-1.flex-grow-1
          .col-md-3.col-sm-6
            router-link(to="/")
              img.logo(src="/assets/img/logo_blue.png" alt="Viral logo")
          .col-sm-6.social.mx-1.mobile
            a.mx-1(href="https://twitter.com/datacivica" target="_blank")
              i.fab.fa-twitter
            a.mx-1(href="https://www.facebook.com/datacivica/" target="_blank")
              i.fab.fa-facebook
            a.mx-1(href="https://www.instagram.com/datacivica/" target="_blank")
              i.fab.fa-instagram
          .col-md-6.menu-items.uppercase.desktop.py-1
            router-link(
              v-for="(item, index) in menu"
              :key="`a${index}`"
              :to="item.slug"
            ) {{item.text}}
          .col-md-3.col-sm-6.social.px-5.desktop
            a(href="https://twitter.com/datacivica" target="_blank")
              i.fab.fa-twitter
            a.pl-1(href="https://www.facebook.com/datacivica/" target="_blank")
              i.fab.fa-facebook
            a.pl-1(href="https://www.instagram.com/datacivica/" target="_blank")
              i.fab.fa-instagram
        .row.home-nav.d-flex.px-0
          .col-md-12.pb-0.pt-4.menu-items.uppercase.mobile
            router-link.mx-1(
              v-for="(item, index) in menu"
              :key="`b${index}`"
              :to="item.slug"
            ) {{item.text}}
</template>

<script>
export default {
  name: "Blogsnavbar",
  data() {
    return {
      menu: [
        {
          text: "La amenaza",
          slug: "/#inicio-amenaza"
        },
        {
          text: "La respuesta",
          slug: "/#inicio-respuesta"
        },
        {
          text: "Las consecuencias",
          slug: "/#inicio-consecuencias"
        }
      ],
      prevScrollpos: window.pageYOffset
    };
  },
  methods: {
    handleScroll() {
      const navbar = document.getElementById("bar");
      if (
        document.body.scrollTop > 700 ||
        document.documentElement.scrollTop > 700
      ) {
        navbar.style.top = "0";
        let currentScrollPos = window.pageYOffset;
        if (this.prevScrollpos > currentScrollPos) {
          navbar.style.top = "0";
        } else {
          navbar.style.top = "-140px";
        }
        this.prevScrollpos = currentScrollPos;
      } else {
        navbar.style.top = "-140px";
      }
    },
    onScroll() {
      window.addEventListener("scroll", this.handleScroll);
    },
  },
  async mounted() {
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss">
#blogsnavbar {
  .blogs-navbar {
    #bar {
      background-color: #fff;
      min-height: 110px;
      position: fixed;
      top: -140px;
      left: 0;
      width: 100%;
      display: block;
      z-index: 100;
      transition: top 0.5s ease-out;
    }
    z-index: 100;
    min-height: 10vh;
    padding: 2rem;
    .home-nav {
      text-align: center;
      justify-content: center;
      align-items: center;
      .desktop {
        display: flex;
      }
      .logo {
        width: 150px;
      }
      .menu-items {
        justify-content: space-around;
        a {
          color: rgba(10, 28, 89, 0.98);
        }
        a:hover {
          color: #34afb2;
          //background-color: rgba(10, 28, 89, 0.98);
          text-decoration: none;
        }
      }
      .social {
        justify-content: space-around;
        i {
          color: rgba(10, 28, 89, 0.98);
          font-size: 1.5rem;
        }
        i:hover {
          color: #34afb2;
          //background-color: rgba(10, 28, 89, 0.98);
        }
      }
    }
  }
}

@media (max-width: 420px) {
  #blogsnavbar {
    .blogs-navbar {
      padding: 6vh 0;
      .home-nav {
        flex-wrap: nowrap;
        .desktop {
          display: none;
        }
        .mobile {
          display: flex;
        }
        .logo {
          width: 100%;
        }
        .social {
          i {
            font-size: 1rem;
          }
        }
        .menu-items {
          font-size: 0.8rem;
        }
      }
    }
  }
}
</style>
